import { FCC } from '@dynamika-shared/types/general';
import { Button } from '@dynamika-shared/ui/Button/Button';
import { twMerge } from 'src/utils/twMerge';

type ButtonProps = React.ComponentProps<typeof Button> & {
  form?: string;
  htmlType?: string;
  ['data-testid']?: string;
};

type BottomConfirmationProps = {
  ['data-testid']?: string;
  childrenClassName?: string;
  className?: string;
  okClassName?: string;
  cancelClassName?: string;
  okText?: string;
  cancelText?: string;
  buttons?: React.ReactNode[];
  onCancel?: () => void;
  onOk?: () => void;
  okProps?: ButtonProps;
  cancelProps?: ButtonProps;
  zIndex?: number;
};
export const BottomConfirmation: FCC<BottomConfirmationProps> = props => {
  return (
    <div
      data-testid={props['data-testid']}
      className={twMerge(
        'fixed bottom-[1.6rem] right-[1.6rem] mb-3 flex max-h-[8.8rem] w-[calc(100%-272px)] items-center justify-between rounded-md bg-white  p-4 shadow-md',
        props.className
      )}
    >
      <h3
        className={twMerge(
          'text-1624 font-medium leading-6 tracking-normal',
          props.childrenClassName
        )}
      >
        {props.children}
      </h3>
      <div className='flex items-center justify-between gap-3'>
        {props.buttons ?? [
          props.onCancel && (
            <Button
              key={'cancel'}
              onClick={props.onCancel}
              className={twMerge('w-[14.4rem]', props.cancelClassName)}
              data-testid={'cancel-BottomConfirmation-btn'}
              {...props.cancelProps}
            >
              <span>{props.cancelText ?? 'Discard'}</span>
            </Button>
          ),
          props.onOk && (
            <Button
              key={'ok'}
              onClick={props.onOk}
              className={twMerge('w-[14.4rem]', props.okClassName)}
              type='primary'
              data-testid={'ok-BottomConfirmation-btn'}
              {...props.okProps}
            >
              <span>{props.okText ?? 'Confirm'}</span>
            </Button>
          ),
        ]}
      </div>
    </div>
  );
};
